import { render, staticRenderFns } from "./BookingServices.vue?vue&type=template&id=6b7cf97f&scoped=true"
import script from "./BookingServices.vue?vue&type=script&lang=ts"
export * from "./BookingServices.vue?vue&type=script&lang=ts"
import style0 from "./BookingServices.vue?vue&type=style&index=0&id=6b7cf97f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7cf97f",
  null
  
)

export default component.exports